import type { QueryClient } from "@tanstack/react-query";
import { NOTIFICATIONS_BELL_UNREAD_PAGE_SIZE } from "@/features/notifications/constants";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";
import { NotificationsApi } from "@/openapi/generated";

const NOTIFICATIONS_UNREAD_STALE_TIME_MS = 30 * 1000;

/** Server prefetch for the notification bell (unread endpoint). */
export async function prefetchNotificationsUnreadGet(
  queryClient: QueryClient,
  userId: number,
  accessToken: string,
  page: number = 1,
  pageSize: number = NOTIFICATIONS_BELL_UNREAD_PAGE_SIZE,
) {
  const service = createAuthenticatedApi(NotificationsApi, accessToken);

  await queryClient.prefetchQuery({
    queryKey: [
      QueryKeys.NotificationsUnread,
      userId,
      page,
      pageSize,
      undefined,
      undefined,
    ],
    queryFn: () =>
      service.apiNotificationsUserIdUnreadGet({
        userId,
        page,
        pageSize,
      }),
    staleTime: NOTIFICATIONS_UNREAD_STALE_TIME_MS,
  });

  return queryClient;
}
